import * as types from "./mutations-type";
export default{
    [types.SET_MSG](state,payload){
        state.msg = payload
    },
    [types.SET_EDITAR](state,payload){
        state.editar = payload
    },
    [types.SET_LISTA](state,payload){
        state.lista = payload
    },
    [types.SET_LISTAEVENTO](state,payload){
        state.listaevento = payload
    },
    [types.SET_LISTADOCUMENTO](state,payload){
        state.doc = payload
    },
    [types.SET_MATRICULA](state,payload){
        state.matricula = payload
    },
    [types.SET_PERFIL](state,payload){
        state.perfil = payload
    },
}